module.exports = __webpack_public_path__ + "img/jeronimos.dcff410c.jpg";